<template>
	<div>
		<post-smtp-notice
			type="success"
			v-if="postSmtpConfigured && ! isLogOnlyMode"
		>
			<template v-slot:title>
				{{ i18n.configured.text }}
			</template>
			

			<template v-slot:button>
				<a :href="send_test_email_url" class="post-smtp-button">
					{{ i18n.configured.button }}
					<i>
						<svg style="margin-bottom: -1px;" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_67_1316)"><path d="M11.8124 0.173758C11.9597 0.280901 12.02 0.423758 11.9932 0.60233L10.2789 10.888C10.2566 11.0175 10.1852 11.118 10.0646 11.1894C10.0021 11.2251 9.93293 11.243 9.85703 11.243C9.80793 11.243 9.75435 11.2318 9.69632 11.2095L6.66284 9.97063L5.0423 11.9461C4.96194 12.0488 4.85257 12.1001 4.71418 12.1001C4.65614 12.1001 4.60703 12.0912 4.56685 12.0733C4.48203 12.0421 4.41395 11.9896 4.36261 11.9159C4.31127 11.8423 4.2856 11.7608 4.2856 11.6715V9.33447L10.0713 2.24295L2.91284 8.43715L0.267747 7.35233C0.102568 7.28983 0.0132824 7.16706 -0.000110445 6.98403C-0.00903902 6.80545 0.0623896 6.67376 0.214175 6.58894L11.357 0.160366C11.424 0.120187 11.4954 0.100098 11.5713 0.100098C11.6606 0.100098 11.741 0.124651 11.8124 0.173758Z" fill="white"/></g><defs><clipPath id="clip0_67_1316"><rect width="12" height="12" fill="white" transform="translate(0 0.100098)"/></clipPath></defs></svg>
					</i>
				</a>
			</template>
		</post-smtp-notice>

		<post-smtp-notice
			type="warning"
			v-if="! postSmtpConfigured && ! isLogOnlyMode"
		>
			<template v-slot:title>
				{{ i18n.notConfigured.text }}
			</template>
			

			<template v-slot:button>
				<a :href="wizard_url" class="post-smtp-button">
					{{ i18n.notConfigured.button }}
					<i>
						<svg style="margin-bottom: -4px;" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M8.293 2.79303C8.48053 2.60556 8.73484 2.50024 9 2.50024C9.26516 2.50024 9.51947 2.60556 9.707 2.79303L14.207 7.29303C14.3945 7.48056 14.4998 7.73487 14.4998 8.00003C14.4998 8.26519 14.3945 8.5195 14.207 8.70703L9.707 13.207C9.5184 13.3892 9.2658 13.49 9.0036 13.4877C8.7414 13.4854 8.49059 13.3803 8.30518 13.1948C8.11977 13.0094 8.0146 12.7586 8.01233 12.4964C8.01005 12.2342 8.11084 11.9816 8.293 11.793L11 9.00003H1.5C1.23478 9.00003 0.98043 8.89467 0.792893 8.70714C0.605357 8.5196 0.5 8.26525 0.5 8.00003C0.5 7.73481 0.605357 7.48046 0.792893 7.29292C0.98043 7.10539 1.23478 7.00003 1.5 7.00003H11L8.293 4.20703C8.10553 4.0195 8.00021 3.76519 8.00021 3.50003C8.00021 3.23487 8.10553 2.98056 8.293 2.79303Z" fill="#EEEEEE"/>
						</svg>
					</i>
				</a>
			</template>
		</post-smtp-notice>

    <post-smtp-notice
        type="warning"
        v-if="isLogOnlyMode"
    >
      <template v-slot:title>
        {{ i18n.isLogOnly.text }}
      </template>


      <template v-slot:button>
        <a :href="wizard_url" class="post-smtp-button">
          {{ i18n.isLogOnly.button }}
          <i>
            <svg style="margin-bottom: -4px;" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.293 2.79303C8.48053 2.60556 8.73484 2.50024 9 2.50024C9.26516 2.50024 9.51947 2.60556 9.707 2.79303L14.207 7.29303C14.3945 7.48056 14.4998 7.73487 14.4998 8.00003C14.4998 8.26519 14.3945 8.5195 14.207 8.70703L9.707 13.207C9.5184 13.3892 9.2658 13.49 9.0036 13.4877C8.7414 13.4854 8.49059 13.3803 8.30518 13.1948C8.11977 13.0094 8.0146 12.7586 8.01233 12.4964C8.01005 12.2342 8.11084 11.9816 8.293 11.793L11 9.00003H1.5C1.23478 9.00003 0.98043 8.89467 0.792893 8.70714C0.605357 8.5196 0.5 8.26525 0.5 8.00003C0.5 7.73481 0.605357 7.48046 0.792893 7.29292C0.98043 7.10539 1.23478 7.00003 1.5 7.00003H11L8.293 4.20703C8.10553 4.0195 8.00021 3.76519 8.00021 3.50003C8.00021 3.23487 8.10553 2.98056 8.293 2.79303Z" fill="#EEEEEE"/>
            </svg>
          </i>
        </a>
      </template>
    </post-smtp-notice>

	</div>
</template>

<script>
export default {
	name: 'post-smtp-banners',

	props: {
		postSmtpConfigured: {
			type: Boolean,
			default: false,
		},

    isLogOnlyMode: {
      type: Boolean,
      default: false,
    },
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
    i18n: postSmtpNewDashboard.i18n.banners,
	} ),

	computed: {
		send_test_email_url() {
			return `${this.admin_url}?page=postman/email_test`;
		},

		wizard_url() {
			return `${this.admin_url}?page=postman/configuration_wizard`;
		}
	},
  mounted() {
    console.log( this.isLogOnlyMode)
  }
}
</script>

<style scoped>
.post-smtp-button {
	display: inline-block;
	padding: 8px 16px !important;
	justify-content: center;
	align-items: center;
	gap: 4px;

	border-radius: 4px;
	background: linear-gradient(95deg, #375CAF 18.84%, #3161CD 84.93%);

	color: #fff;

	text-decoration: none;

	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 18px; /* 150% */
}
</style>